<rt-dialog-header
  [heading]="'tlc.members.add_employee_for_preonboarding_dialog.heading' | translate"
  [subheading]="'tlc.members.add_employee_for_preonboarding_dialog.subheading' | translate"
/>
<rt-dialog-body variant="white">
  <form [formGroup]="formGroup" class="dialog-content">
    <div formArrayName="employees" class="dialog-form">
      @for (item of employees; track item.getRawValue()) {
        <div class="details-item" [formGroupName]="$index">
          <rt-form-field [required]="hasAnyEmptyEmail()" class="email-field">
            @if ($first) {
              <rt-label>{{
                'tlc.members.add_employee_for_preonboarding_dialog.form.personal_email' | translate
              }}</rt-label>
            }
            <rt-input
              [rtFormError]="emailFieldErrors"
              [placeholder]="
                'tlc.members.add_employee_for_preonboarding_dialog.form.personal_email_placeholder'
                  | translate
              "
              formControlName="personalEmail"
              type="email"
              rtProtectedControl
            />
          </rt-form-field>
          <rt-form-field [required]="hasAnyEmptyFirstName()" class="first-name">
            @if ($first) {
              <rt-label>{{
                'tlc.members.add_employee_for_preonboarding_dialog.form.first_name' | translate
              }}</rt-label>
            }
            <rt-input
              [rtFormError]="nameFieldErrors"
              [placeholder]="
                'tlc.members.add_employee_for_preonboarding_dialog.form.first_name_placeholder'
                  | translate
              "
              formControlName="firstName"
              rtProtectedControl
            />
          </rt-form-field>
          <rt-form-field [required]="hasAnyEmptyLastName()" class="last-name">
            @if ($first) {
              <rt-label>{{
                'tlc.members.add_employee_for_preonboarding_dialog.form.last_name' | translate
              }}</rt-label>
            }
            <rt-input
              [rtFormError]="nameFieldErrors"
              [placeholder]="
                'tlc.members.add_employee_for_preonboarding_dialog.form.last_name_placeholder'
                  | translate
              "
              formControlName="lastName"
              rtProtectedControl
            />
          </rt-form-field>
          @if (employees.length > 1) {
            <rt-form-field>
              <rt-label />
              <rt-icon-button
                (click)="removeMemberFormGroup($index)"
                iconName="close"
                variant="plain"
                class="remove-form-group-button"
              />
            </rt-form-field>
          }
        </div>
      }
    </div>
    <div class="add-button-wrap">
      <rt-button
        [disabled]="formGroup.invalid || !canAddRow()"
        (click)="addMemberFormGroup()"
        variant="plain"
      >
        <rt-icon prefix name="add" />
        <span>{{ 'tlc.members.add_member.form.add_next' | translate }}</span>
      </rt-button>
    </div>
  </form>
</rt-dialog-body>
<rt-dialog-footer>
  <rt-button variant="plain" (click)="cancel()">{{ 'tlc.common.cancel' | translate }}</rt-button>
  <rt-button variant="primary" [loading]="loading()" (click)="continue()">{{
    'tlc.common.continue' | translate
  }}</rt-button>
</rt-dialog-footer>
